<ngx-spinner
    name="managementSpinner"
    color="#fff"
    size="medium"
    type="ball-clip-rotate-multiple">
    <p style="font-size: 20px; color: white">Uploading media...</p></ngx-spinner>

<div class="sm:absolute sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent"
     @zoomIn>

    <!-- Header -->
    <div
        class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b">
        <!-- Title -->

        <div
            class="text-4xl font-extrabold tracking-tight w-full lg:w-1/4">{{ layout.ds_title }}
        </div>

        <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <!-- Preview -->
            <button
                class="ml-4"
                mat-stroked-button
                (click)="sendCommand(null)">
                Back
            </button>
            <!-- Preview -->
            <button
                class="ml-4"
                mat-stroked-button
                [color]="'primary'"
                (click)="saveAndClose(true)">
                Save
            </button>
        </div>

    </div>

    <mat-tab-group class="pt-2 md:px-2 full-height-tabs" [animationDuration]="'0ms'" [(selectedIndex)]="selectedIndex"
                   (selectedTabChange)="onTabChange($event)">

        <mat-tab label="General">
            <div class="pb-26 pr-4 max-h-fit">


                <mat-label class="flex"><h1>Content General Data</h1></mat-label>

                <br>

                <!-- Name -->
                <mat-label class="flex"><p>ID Display Layout</p>
                </mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        disabled
                        matInput
                        [(ngModel)]="layout.id_displaylayout">
                </mat-form-field>

                <!-- Name -->
                <mat-label class="flex"><p>ID Destination Type Layout</p></mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        disabled
                        matInput
                        [(ngModel)]="layout.id_destinationtypelayout">
                </mat-form-field>

                <!-- Name -->
                <mat-label class="flex"><p>ID Destination Type</p></mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        disabled
                        matInput
                        [(ngModel)]="layout.id_destinationtype">
                </mat-form-field>

                <!-- Name -->
                <mat-label class="flex"><p>Title</p></mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        (input)="onInputMaxReach($event, 250)"
                        maxlength="250"
                        matInput
                        [(ngModel)]="layout.ds_title">
                </mat-form-field>

                <!-- Name -->
                <mat-label class="flex"><p>Subtitle</p></mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        (input)="onInputMaxReach($event, 250)"
                        maxlength="250"
                        matInput
                        [(ngModel)]="layout.ds_subtitle">
                </mat-form-field>

                <hr>


                <mat-label class="flex"><h1>Technical General Data</h1></mat-label>

                <br>

                <div class="flex w-full lg:w-3/4 pb-2">

                    <mat-form-field [subscriptSizing]="'dynamic'"
                                    class="w-full lg:w-1/6 pr-2 d-flex justify-content-center">
                        <mat-label class="flex pr-5"><p>Parent Option:</p>
                            <mat-icon svgIcon="heroicons_outline:exclamation-circle" class="pb-2"
                                      matTooltip="Toggle for Parent Destination on Cities"></mat-icon>
                        </mat-label>
                        <mat-slide-toggle
                            [(ngModel)]="layout.bl_addgparenttocities">{{ layout.bl_addgparenttocities ? 'Active' : 'Inactive' }}
                        </mat-slide-toggle>
                        <textarea matInput hidden></textarea>
                    </mat-form-field>

                    <mat-form-field [subscriptSizing]="'dynamic'"
                                    class="w-full lg:w-1/6 pr-2 d-flex justify-content-center">
                        <mat-label class="flex pr-5"><p>Props Option:</p>
                            <mat-icon svgIcon="heroicons_outline:exclamation-circle" class="pb-2"
                                      matTooltip="Toggle for Props in Cities"></mat-icon>
                        </mat-label>
                        <mat-slide-toggle
                            [(ngModel)]="layout.bl_addnavigationprops">{{ layout.bl_addnavigationprops ? 'Active' : 'Inactive' }}
                        </mat-slide-toggle>
                        <textarea matInput hidden></textarea>
                    </mat-form-field>

                    <mat-form-field [subscriptSizing]="'dynamic'"
                                    class="w-full lg:w-1/6 pr-2 d-flex justify-content-center">
                        <mat-label class="flex pr-5"><p>Hide Destinations:</p>
                            <mat-icon svgIcon="heroicons_outline:exclamation-circle" class="pb-2"
                                      matTooltip="Toggle for Hide Destinations In City"></mat-icon>
                        </mat-label>
                        <mat-slide-toggle
                            [(ngModel)]="layout.bl_hidedestinations">{{ layout.bl_hidedestinations ? 'Active' : 'Inactive' }}
                        </mat-slide-toggle>
                        <textarea matInput hidden></textarea>
                    </mat-form-field>

                </div>

                <!-- Name -->
                <mat-label class="flex"><p>Data</p></mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        (input)="onInputMaxReach($event, 250)"
                        maxlength="250"
                        matInput
                        [(ngModel)]="layout.ds_data">
                </mat-form-field>

                <!-- Name -->
                <mat-label class="flex"><p>Override Destination Target</p></mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        (input)="onInputMaxReach($event, 250)"
                        maxlength="250"
                        matInput
                        [(ngModel)]="layout.ds_overridedestinationtarget">
                </mat-form-field>

                <!-- Name -->
                <mat-label class="flex"><p>URL Target</p></mat-label>
                <mat-form-field class="w-full lg:w-2/3 pr-2">
                    <input
                        (input)="onInputMaxReach($event, 250)"
                        maxlength="250"
                        matInput
                        [(ngModel)]="layout.ds_url">
                </mat-form-field>

            </div>
        </mat-tab>

        <mat-tab label="Components Content Data">
            <ng-template matTabContent>
                <div
                    class="sm:absolute pt-2 px-6 sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
                    <!-- Main -->
                    <div class="flex flex-auto overflow-hidden">
                        <!-- Products list -->
                        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                            <div class="grid" cdkDropList (cdkDropListDropped)="drop($event)">
                                <!-- Header -->
                                <div
                                    class="table-types-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black">
                                    <div class="mt-2">Order</div>
                                    <div class="mt-2">Type</div>
                                    <div class="mt-2">Title</div>
                                    <div class="hidden lg:block mt-2">Details</div>
                                </div>
                                <!-- Rows -->
                                <ng-container *ngIf="componentList.length > 0">
                                    <div *ngFor="let component of componentList; let i = index"
                                         cdkDrag
                                         [cdkDragDisabled]="selectedComponent !== null"
                                         [ngClass]="{'hover:bg-amber-400/50': selectedComponent === null}">
                                        <div
                                            class="table-types-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b relative">
                                            <!-- Order -->
                                            <div class="truncate">
                                                {{ component.order }}
                                            </div>
                                            <!-- Type -->
                                            <div class="truncate">
                                                {{ component.ds_en_sectiontype }}
                                            </div>
                                            <!-- Title -->
                                            <div class="truncate">
                                                {{ component.ds_title }}
                                            </div>
                                            <!-- Details button -->
                                            <div class="flex items-center">
                                                <button
                                                    class="relative flex flex-0 items-center justify-center w-12 h-12 mr-6 overflow-hidden"
                                                    mat-stroked-button
                                                    (click)="toggleDetails(component.order)">
                                                    <mat-icon class="icon-size-5"
                                                              [svgIcon]="selectedComponent?.order === component.order ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'">
                                                    </mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="grid">
                                            <ng-container *ngIf="selectedComponent?.order === component.order">
                                                <ng-container
                                                    *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: component}"></ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <ng-template #rowDetailsTemplate>
                                <div class="shadow-lg overflow-hidden">
                                    <div class="flex border-b">
                                        <!-- Selected product form -->
                                        <div class="flex flex-col w-full">

                                            <div class="flex flex-col sm:flex-row p-8">

                                                <div class="flex flex-auto flex-wrap">
                                                    <!-- Name, SKU & etc. -->
                                                    <div class="flex flex-col w-full lg:w-2/4 sm:pl-8">

                                                        <!-- Name -->

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Title</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_title">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Subtitle</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_subtitle">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Action Title</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_actiontitle">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Action Subtitle</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_actionsubtitle">
                                                            </mat-form-field>
                                                        </div>

                                                    </div>

                                                    <!-- Name, SKU & etc. -->
                                                    <div class="flex flex-col w-full lg:w-2/4 sm:pl-8">

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "A" Label</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_buttonalabel">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "B" Label</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_buttonblabel">
                                                            </mat-form-field>
                                                        </div>

                                                        <hr>

                                                        <!-- SKU and Barcode -->
                                                        <div class="flex">
                                                            <mat-form-field class="w-full pr-0 lg:pr-4 lg:w-1/4">
                                                                <mat-label>Order</mat-label>
                                                                <mat-select [(ngModel)]="orderSelected">
                                                                    <ng-container *ngFor="let order of orderList">
                                                                        <mat-option [value]="order">
                                                                            {{ order }}
                                                                        </mat-option>
                                                                    </ng-container>
                                                                </mat-select>
                                                            </mat-form-field>

                                                            <mat-form-field class="w-full lg:w-1/4">
                                                                <mat-label>Component Selector</mat-label>
                                                                <mat-select
                                                                    (selectionChange)="changeComponentTypeName($event)"
                                                                    [(ngModel)]="selectedComponent.en_sectiontype">
                                                                    <ng-container *ngFor="let cmp of componentTypeList">
                                                                        <mat-option [value]="cmp.value">
                                                                            {{ cmp.name }} : {{ cmp.value }}
                                                                        </mat-option>
                                                                    </ng-container>
                                                                </mat-select>
                                                            </mat-form-field>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                            <div class="flex items-center justify-between w-full border-t px-8 py-4">
                                                <div class="flex items-center">
                                                    <div
                                                        class="flex items-center mr-4"
                                                        *ngIf="flashMessage">
                                                        <ng-container *ngIf="flashMessage === 'success'">
                                                            <mat-icon
                                                                class="text-green-500"
                                                                [svgIcon]="'heroicons_outline:check'"></mat-icon>
                                                            <span class="ml-2">Component updated</span>
                                                        </ng-container>
                                                        <ng-container *ngIf="flashMessage === 'error'">
                                                            <mat-icon
                                                                class="text-red-500"
                                                                [svgIcon]="'heroicons_outline:x'"></mat-icon>
                                                            <span class="ml-2">An error occurred, try again!</span>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <button
                                                    mat-stroked-button
                                                    [color]="'primary'"
                                                    (click)="saveSpecialOffer()">
                                                    Save
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </ng-template>

                        </div>

                    </div>

                </div>
            </ng-template>
        </mat-tab>

        <mat-tab label="Components Technical Data">
            <ng-template matTabContent>
                <div
                    class="sm:absolute pt-2 px-6 sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
                    <!-- Main -->
                    <div class="flex flex-auto overflow-hidden">
                        <!-- Products list -->
                        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                            <div class="grid">
                                <!-- Header -->
                                <div
                                    class="table-types-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black">
                                    <div class="mt-2">Order</div>
                                    <div class="mt-2">Type</div>
                                    <div class="mt-2">Title</div>
                                    <div class="hidden lg:block mt-2">Details</div>
                                </div>
                                <!-- Rows -->
                                <ng-container *ngIf="componentList.length > 0">
                                    <ng-container *ngFor="let component of componentList">
                                        <div
                                            class="table-types-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b">
                                            <!-- Order -->
                                            <div class="truncate">
                                                {{ component.order }}
                                            </div>
                                            <!-- Type -->
                                            <div class="truncate">
                                                {{ component.ds_en_sectiontype }}
                                            </div>
                                            <!-- Title -->
                                            <div class="truncate">
                                                {{ component.ds_title }}
                                            </div>
                                            <!-- Details button -->
                                            <div class="flex items-center">
                                                <button
                                                    class="relative flex flex-0 items-center justify-center w-12 h-12 mr-6 overflow-hidden"
                                                    mat-stroked-button
                                                    (click)="toggleDetails(component.order)">
                                                    <mat-icon
                                                        class="icon-size-5"
                                                        [svgIcon]="selectedComponent?.order === component.order ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'"></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="grid">
                                            <ng-container
                                                *ngIf="selectedComponent?.order === component.order">
                                                <ng-container
                                                    *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: component}"></ng-container>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <ng-template #rowDetailsTemplate>
                                <div class="shadow-lg overflow-hidden">
                                    <div class="flex border-b">
                                        <!-- Selected product form -->
                                        <div class="flex flex-col w-full">

                                            <div class="flex flex-col sm:flex-row p-8">

                                                <div class="flex flex-auto flex-wrap">
                                                    <!-- Name, SKU & etc. -->
                                                    <div class="flex flex-col w-full lg:w-2/4 sm:pl-8">

                                                        <!-- Name -->

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Layout</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_layout">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>URL</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_url">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Data</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_data">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Image</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.im_image">
                                                            </mat-form-field>
                                                        </div>

                                                        <hr>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Action Type Name</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_en_actiontype">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Action Type ID</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.en_actiontype">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Action URL</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_actionurl">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Action Data</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_actiondata">
                                                            </mat-form-field>
                                                        </div>

                                                    </div>

                                                    <!-- Name, SKU & etc. -->
                                                    <div class="flex flex-col w-full lg:w-2/4 sm:pl-8">

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "A" Type Name</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_en_buttonatype">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "A" Type ID</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.en_buttonatype">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "A" Data</mat-label>
                                                                <input
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_buttonadata">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "A" URL</mat-label>
                                                                <input
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_buttonaurl">
                                                            </mat-form-field>
                                                        </div>

                                                        <hr>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "B" Type Name</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_en_buttonbtype">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "B" Type ID</mat-label>
                                                                <input
                                                                    (input)="onInputMaxReach($event, 150)"
                                                                    maxlength="150"
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.en_buttonbtype">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "B" Data</mat-label>
                                                                <input
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_buttonbdata">
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="flex">
                                                            <mat-form-field class="w-full">
                                                                <mat-label>Button "B" URL</mat-label>
                                                                <input
                                                                    matInput
                                                                    [(ngModel)]="selectedComponent.ds_buttonburl">
                                                            </mat-form-field>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                            <div class="flex items-center justify-between w-full border-t px-8 py-4">
                                                <div class="flex items-center">
                                                    <div
                                                        class="flex items-center mr-4"
                                                        *ngIf="flashMessage">
                                                        <ng-container *ngIf="flashMessage === 'success'">
                                                            <mat-icon
                                                                class="text-green-500"
                                                                [svgIcon]="'heroicons_outline:check'"></mat-icon>
                                                            <span class="ml-2">Component updated</span>
                                                        </ng-container>
                                                        <ng-container *ngIf="flashMessage === 'error'">
                                                            <mat-icon
                                                                class="text-red-500"
                                                                [svgIcon]="'heroicons_outline:x'"></mat-icon>
                                                            <span class="ml-2">An error occurred, try again!</span>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <button
                                                    mat-stroked-button
                                                    [color]="'primary'"
                                                    (click)="saveSpecialOffer()">
                                                    Save
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </ng-template>

                        </div>

                    </div>

                </div>
            </ng-template>
        </mat-tab>

    </mat-tab-group>

</div>
